/* eslint-disable import/no-cycle */
import { all, call } from 'redux-saga/effects';

import authWatch from 'modules/auth/sagas';
import dashboardWatcher from 'modules/dashboards/sagas';
import gymsWatch from 'modules/gyms/sagas';
import holidayHoursWatcher from 'modules/holiday-hours/sagas';
import incomeReportWatcher from 'modules/income-report/sagas';
import meWatch from 'modules/me/sagas';
import reportsWatcher from 'modules/reports/sagas';
import rolesWatcher from 'modules/roles/sagas';
import { routinePromiseWatcherSaga } from 'redux-saga-routines';
import settingsWatcher from 'modules/settings/sagas';
import skusWatcher from 'modules/sku-manager/sagas';
import stdHoursWatcher from 'modules/std-hours/sagas';
import usersWatcher from 'modules/users/sagas';
import { lookerUrlWatcher, keyMetricsUrlWatcher } from 'modules/looker/sagas';
import emailsWatcher from 'modules/emails/sagas';
import snowflakeWatcher from 'modules/snowflake/sagas';
import networkPerformanceWatcher from 'modules/network-performance/sagas';
import financialReportWatcher from 'modules/financial-report/sagas';

function* rootSaga() {
  try {
    yield all([
      // external
      call(routinePromiseWatcherSaga),

      // app
      call(authWatch),
      call(meWatch),
      call(stdHoursWatcher),
      call(gymsWatch),
      call(usersWatcher),
      call(rolesWatcher),
      call(holidayHoursWatcher),
      call(dashboardWatcher),
      call(skusWatcher),
      call(reportsWatcher),
      call(settingsWatcher),
      call(incomeReportWatcher),
      call(lookerUrlWatcher),
      call(emailsWatcher),
      call(keyMetricsUrlWatcher),
      call(snowflakeWatcher),
      call(networkPerformanceWatcher),
      call(financialReportWatcher),
    ]);
  } catch (error) {
    // If any watcher escapes, the whole root saga dies and the app freezes
    // with no feedback — surface it so it's diagnosable.
    console.error('rootSaga crashed', error);
    throw error;
  }
}

export default rootSaga;
